import { Aviso } from '@/shared/ui/Aviso/Aviso'
import { Boton } from '@/shared/ui/Boton/Boton'

import estilos from './DecidirCotizacion.module.css'

export type Envio = { enlace: string; salio: boolean; motivo: string | null }

/**
 * Lo que pasó al mandarle la cotización al cliente.
 *
 * SE DICE SI SALIÓ O NO SALIÓ. El enlace se enseña en los dos casos —el
 * cliente los pierde y quien atiende la llamada tiene que poder repetírselo—
 * pero afirmar «le llega por WhatsApp» cuando no salió es peor que callarse:
 * nadie copia un enlace que cree que ya está en el teléfono del cliente.
 *
 * Lo usan la ficha de la orden y el ofrecimiento al armar o enlazar, para
 * que el mismo hecho se diga igual en todas partes.
 */
export function ResultadoDelEnvio({ envio }: { envio: Envio }) {
  const copiar = (
    <Boton variante="plano" onClick={() => void navigator.clipboard.writeText(envio.enlace)}>
      Copiar el enlace
    </Boton>
  )
  return envio.salio ? (
    <Aviso tipo="exito" titulo="Enviada al cliente">
      Le llegó por WhatsApp para que la acepte. En cuanto acepte, la orden de trabajo nace sola y
      pasa a programación. Este es el mismo enlace, por si hay que repetírselo:
      <code className={estilos.enlace}>{envio.enlace}</code>
      {copiar}
    </Aviso>
  ) : (
    <Aviso tipo="alerta" titulo="Aprobada, pero el WhatsApp no salió">
      La cotización quedó lista y esperando al cliente; lo que falló fue el mensaje
      {envio.motivo ? ` (${envio.motivo})` : ''}. Mándele este enlace por donde pueda:
      <code className={estilos.enlace}>{envio.enlace}</code>
      {copiar}
    </Aviso>
  )
}
